import React from 'react';
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { Dac7ReportResponse } from '../../../common/api/dac7Service';
import { LOADING_STATUS } from '../../../common/constants';

type MarkSubmittedCardProps = {
  reports: Dac7ReportResponse[];
  submitReportId: string;
  submissionNotes: string;
  markAsSubmittedStatus: LOADING_STATUS;
  onSubmitReportChange: (value: string) => void;
  onSubmissionNotesChange: (value: string) => void;
  onMarkAsSubmitted: () => void;
};

function MarkSubmittedCard({
  reports,
  submitReportId,
  submissionNotes,
  markAsSubmittedStatus,
  onSubmitReportChange,
  onSubmissionNotesChange,
  onMarkAsSubmitted,
}: MarkSubmittedCardProps) {
  return (
    <Card className="bg-white border shadow-none p-24 mb-24">
      <h5 className="mb-16">Merkitse raportti lähetetyksi</h5>
      <p className="text-muted mb-16">
        Kun olet lähettänyt DAC7 XML-tiedoston Ilmoitin-palveluun, merkitse
        raportti lähetetyksi tässä. Tämä lukitsee raportin, eikä sitä voi enää
        generoida uudelleen (OECD1). Vain korjaukset (OECD2) ja poistot (OECD3)
        ovat mahdollisia lähetetyn raportin jälkeen.
      </p>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-16">
            <Form.Label>Valitse raportti</Form.Label>
            <Form.Select
              value={submitReportId}
              onChange={e => onSubmitReportChange(e.target.value)}
              disabled={markAsSubmittedStatus === LOADING_STATUS.LOADING}
            >
              <option value="">-- Valitse raportti --</option>
              {reports
                .filter(
                  r =>
                    r.status !== 'Draft' && r.status !== 'SubmittedToIlmoitin',
                )
                .map(report => (
                  <option key={report.id} value={report.id}>
                    {report.reportingYear} - {report.messageRefId} (
                    {report.status})
                  </option>
                ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={5}>
          <Form.Group className="mb-16">
            <Form.Label>Muistiinpanot (valinnainen)</Form.Label>
            <Form.Control
              type="text"
              value={submissionNotes}
              onChange={e => onSubmissionNotesChange(e.target.value)}
              placeholder="Esim. vahvistusnumero Ilmoittimesta..."
              disabled={markAsSubmittedStatus === LOADING_STATUS.LOADING}
            />
          </Form.Group>
        </Col>
        <Col md={3} className="d-flex align-items-end">
          <Button
            variant="success"
            onClick={onMarkAsSubmitted}
            disabled={
              markAsSubmittedStatus === LOADING_STATUS.LOADING ||
              !submitReportId
            }
            className="mb-16 w-100"
          >
            {markAsSubmittedStatus === LOADING_STATUS.LOADING ? (
              <>
                <Spinner size="sm" className="me-2" />
                Merkitään...
              </>
            ) : (
              'Merkitse lähetetyksi'
            )}
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default MarkSubmittedCard;
